import { useEffect, useState } from 'react';

/**
 * A clock that advances once a minute, for a label that ages on screen: «5
 * минут назад» has to become «6 минут назад» without a message arriving to
 * force the render.
 *
 * It runs only while `active`, because nothing else in this app redraws on a
 * timer and a header that says «в сети» has nothing to count. Visibility is
 * watched as well as the interval: a phone that slept through an hour fires no
 * timer, and the stale minute count is precisely what someone reads when they
 * unlock it.
 */
export function useMinuteTick(active: boolean): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active) return;
    // The clock may have been left behind while this was switched off.
    setNow(Date.now());

    const timer = setInterval(() => setNow(Date.now()), 60_000);
    const onVisibility = () => {
      if (document.visibilityState === 'visible') setNow(Date.now());
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [active]);

  return now;
}
